import styled from "styled-components";
import { siteDarkBlue, siteGray } from "../../providers/Theme";
import {
  bodyFontBase,
  bodyFontMd,
  buttonFontSize
} from "../shared.styled.components";
import PinkGradient from "../../assets/faded-pink-gradient.png";

export const ThankYouHero = styled.section`
  position: relative;
  z-index: 0;
  padding: 4rem 2rem 4.5rem;
  text-align: center;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-image: url(${PinkGradient});
    background-size: cover;
    background-position: center;
    z-index: 0;
  }
`;

export const ThankYouInner = styled.div`
  position: relative;
  z-index: 1;
  max-width: 72rem;
  margin: 0 auto;
`;

export const ThankYouHeadline = styled.h1`
  color: ${siteDarkBlue};
  font-weight: 800;
  font-size: 2.2rem;
  line-height: 1.15;
  margin-bottom: 1.25rem;

  ${({ theme }) => theme.md`
    font-size: 2.8rem;
  `}

  ${({ theme }) => theme.xl`
    font-size: 3.5rem;
  `}
`;

export const ThankYouSubtext = styled.p`
  color: ${siteDarkBlue};
  font-size: ${bodyFontBase};
  line-height: 1.7;
  max-width: 44rem;
  margin: 0 auto;

  ${({ theme }) => theme.md`
    font-size: ${bodyFontMd};
  `}
`;

export const GratitudeSection = styled.section`
  background: white;
  padding: 3rem 2rem 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${({ theme }) => theme.lg`
    padding: 4rem 4rem 5rem;
  `}
`;

export const GratitudeCard = styled.div`
  background: ${siteGray};
  border-radius: 14px;
  padding: 2rem 2.25rem;
  width: 100%;
  max-width: 900px;
`;

export const GratitudeBody = styled.p`
  color: ${siteDarkBlue};
  font-size: ${bodyFontBase};
  line-height: 1.75;
  margin-bottom: 1.25rem;

  ${({ theme }) => theme.md`
    font-size: ${bodyFontMd};
  `}
`;

export const GratitudeClosing = styled.p`
  color: ${siteDarkBlue};
  font-size: ${bodyFontBase};
  margin-top: 1.5rem;
  margin-bottom: 0.35rem;
`;

export const SignerName = styled.p`
  color: ${siteDarkBlue};
  font-weight: 700;
  font-size: ${bodyFontMd};
  margin-bottom: 0.15rem;
`;

export const SignerTitle = styled.p`
  color: ${siteDarkBlue};
  font-size: ${bodyFontBase};
  margin: 0;
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
`;

export const HomeButton = styled.a`
  display: inline-block;
  background: ${siteDarkBlue};
  color: white;
  font-weight: 700;
  font-size: ${buttonFontSize};
  text-decoration: none;
  border: 2px solid ${siteDarkBlue};
  border-radius: 0.5rem;
  padding: 0.75rem 2rem;
  cursor: pointer;
  transition: filter 0.15s ease;

  &:hover {
    filter: brightness(0.9);
    color: white;
  }
`;

export const CoursesButton = styled.a`
  display: inline-block;
  background: white;
  color: ${siteDarkBlue};
  font-weight: 700;
  font-size: ${buttonFontSize};
  text-decoration: none;
  border: 2px solid ${siteDarkBlue};
  border-radius: 0.5rem;
  padding: 0.75rem 2rem;
  cursor: pointer;
  transition:
    background 0.15s ease,
    color 0.15s ease;

  &:hover {
    background: ${siteDarkBlue};
    color: white;
  }
`;
